/* Loft Home — theme.js (no dependencies) */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = window.moneyFormat || '£{{amount}}';
    const value = (Number(cents) / 100);
    const withDelims = (n, d, t, c) => {
      const parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(c);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }
  window.LoftMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  /* ---------- Drawers (accessible: focus trap, Esc, return focus) ---------- */
  const focusableSel = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  let lastTrigger = null;

  function openDrawer(id, trigger) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    lastTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[aria-controls="' + id + '"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    const first = $(focusableSel, $('.drawer__panel', drawer));
    setTimeout(() => first && first.focus(), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    $$('[aria-controls="' + drawer.id + '"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  window.LoftDrawer = { open: openDrawer, close: closeDrawer };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener && !(opener.getAttribute('data-drawer-open') === 'CartDrawer' && window.cartType === 'page')) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'), opener);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', (e) => {
    const open = $('.drawer.is-open');
    if (!open) return;
    if (e.key === 'Escape') { closeDrawer(open); return; }
    if (e.key === 'Tab') {
      const items = $$(focusableSel, open).filter(el => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Mega menu (hover + keyboard) ---------- */
  $$('[data-mega-item]').forEach((item) => {
    const btn = $('.nav__link', item);
    let timer;
    const open = () => {
      clearTimeout(timer);
      $$('[data-mega-item].is-open').forEach(o => { if (o !== item) { o.classList.remove('is-open'); $('.nav__link', o).setAttribute('aria-expanded', 'false'); } });
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', () => { timer = setTimeout(close, 120); });
    btn.addEventListener('click', (e) => {
      if (btn.tagName === 'BUTTON') { e.preventDefault(); item.classList.contains('is-open') ? close() : open(); }
    });
    item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); btn.focus(); } });
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(); });
  });

  /* ---------- Header search toggle ---------- */
  $$('[data-search-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      const willOpen = panel.hidden;
      panel.hidden = !willOpen;
      btn.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) { const input = $('input[type="search"]', panel); input && input.focus(); }
    });
  });

  /* ---------- Announcement rotation (mobile only) ---------- */
  $$('[data-announcement]').forEach((list) => {
    const items = $$('.announcement__item', list);
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    list.classList.add('is-rotating');
    items[0].classList.add('is-active');
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const input = $('input', btn.closest('.quantity'));
    if (!input) return;
    const step = Number(btn.getAttribute('data-qty-change'));
    const min = Number(input.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  const Cart = {
    async refresh() {
      const contents = $('[data-cart-contents]');
      try {
        const res = await fetch(window.routes.cart_url + '?section_id=cart-drawer');
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-cart-contents]', doc);
        if (fresh && contents) contents.innerHTML = fresh.innerHTML;
        const count = fresh ? fresh.getAttribute('data-count') : null;
        if (count !== null) {
          $$('[data-cart-count]').forEach(el => { el.textContent = count; el.setAttribute('data-count', count); });
        }
      } catch (err) { console.error('[cart] refresh failed', err); }
    },
    async add(formData) {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || window.themeStrings.cartError);
      return data;
    },
    async change(line, quantity) {
      const contents = $('[data-cart-contents]');
      contents && contents.classList.add('is-updating');
      try {
        const res = await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line, quantity })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || window.themeStrings.cartError);
        await Cart.refresh();
      } catch (err) {
        toast(err.message || window.themeStrings.cartError);
      } finally {
        contents && contents.classList.remove('is-updating');
      }
    }
  };
  window.LoftCart = Cart;

  // Drawer quantity + remove
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-line-qty]');
    if (!input) return;
    Cart.change(Number(input.getAttribute('data-cart-line-qty')), Number(input.value));
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    Cart.change(Number(rm.getAttribute('data-cart-remove')), 0);
  });

  // Product forms
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || window.cartType === 'page') return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    const error = $('[data-form-error]', form);
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.classList.add('is-loading');
    button.setAttribute('aria-disabled', 'true');
    if (error) { error.hidden = true; error.textContent = ''; }
    try {
      await Cart.add(new FormData(form));
      await Cart.refresh();
      openDrawer('CartDrawer', button);
    } catch (err) {
      if (error) { error.textContent = err.message; error.hidden = false; }
      else toast(err.message);
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
    }
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = form && $('input[name="id"]', form);
    const picker = $('[data-variant-picker]', root);
    if (!picker || !idInput) return;

    const selected = () => $$('fieldset[data-option-index]', picker).map(fs => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    function update() {
      const values = selected();
      const variant = product.variants.find(v => v.options.every((o, i) => o === values[i]));
      // Show chosen values in legends
      $$('fieldset[data-option-index]', picker).forEach((fs, i) => {
        const out = $('[data-selected-value]', fs);
        if (out) out.textContent = values[i] || '';
      });
      // Mark unavailable combinations for each option value
      $$('fieldset[data-option-index]', picker).forEach((fs) => {
        const idx = Number(fs.getAttribute('data-option-index'));
        $$('input', fs).forEach(input => {
          const test = values.slice(); test[idx] = input.value;
          const match = product.variants.find(v => v.options.every((o, i) => o === test[i]));
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });

      const buttons = $$('[data-add-button]', root.ownerDocument);
      if (!variant) {
        buttons.forEach(b => { b.setAttribute('aria-disabled', 'true'); b.disabled = true; $('span', b).textContent = window.themeStrings.unavailable; });
        return;
      }
      idInput.value = variant.id;
      buttons.forEach(b => {
        b.disabled = !variant.available;
        $('span', b).textContent = variant.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      });

      // Price
      $$('[data-price]', root.ownerDocument).forEach(priceEl => {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.classList.toggle('price--on-sale', !!onSale);
        const cur = $('.price__current', priceEl);
        const cmp = $('.price__compare', priceEl);
        if (cur) cur.textContent = formatMoney(variant.price);
        if (cmp) { cmp.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; cmp.hidden = !onSale; }
      });

      // Media
      if (variant.featured_media) {
        const slide = $('[data-media-id="' + variant.featured_media.id + '"]', root);
        if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      // URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.addEventListener('change', update);
    update();
  });

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach((gallery) => {
    const track = $('.gallery__slides', gallery);
    const slides = $$('.gallery__slide', gallery);
    const thumbs = $$('.gallery__thumbs button', gallery);
    const counter = $('[data-gallery-counter]', gallery);
    if (!track || !slides.length) return;
    const go = (i) => {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    };
    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    $('[data-gallery-prev]', gallery)?.addEventListener('click', () => go(current() - 1));
    $('[data-gallery-next]', gallery)?.addEventListener('click', () => go(current() + 1));
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = current();
        thumbs.forEach((t, j) => t.setAttribute('aria-current', String(i === j)));
        if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      });
    });
  });

  /* ---------- Sticky add to cart (mobile) ---------- */
  const sticky = $('[data-sticky-atc]');
  const mainAtc = $('[data-main-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(mainAtc);
    const stickyBtn = $('button', sticky);
    stickyBtn && stickyBtn.addEventListener('click', () => {
      const form = mainAtc.closest('form');
      form && form.requestSubmit();
    });
  }

  /* ---------- Sliders ---------- */
  $$('[data-slider]').forEach((wrap) => {
    const scroll = (dir) => {
      const track = $('.slider', wrap);
      if (!track) return;
      const first = track.firstElementChild;
      const step = first ? first.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    };
    $('[data-slider-prev]', wrap)?.addEventListener('click', () => scroll(-1));
    $('[data-slider-next]', wrap)?.addEventListener('click', () => scroll(1));
  });

  /* ---------- Collection: auto-submit sort ---------- */
  $$('[data-autosubmit]').forEach((el) => {
    el.addEventListener('change', () => el.form && el.form.submit());
  });
})();
